<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <mtc-button @click="handleAdd" type="primary" icon="plus" text="button.add"></mtc-button>
      <a-button @click="batchDel" v-if="selectedRowKeys.length > 0" ghost type="primary" icon="delete"
      >{{ $t('button.batchDelete') }}
      </a-button>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{ $t('tip.selected') }}&nbsp;
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>
      <a-table :columns="columns"
               :scroll="{ x: 1500 }"
               size="middle"
               :pagination="false"
               :dataSource="dataSource"
               :loading="loading"
               :expandedRowKeys="expandedRowKeys"
               :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
               @expandedRowsChange="handleExpandedRowsChange">
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
        <template slot="menuType" slot-scope="text">
          <div v-if="text <= 1">{{ $t('label.menu') }}</div>
          <div v-else-if="text == 2">{{ $t('label.buttonsPermissions') }}</div>
          <div v-else>{{ text }}</div>
        </template>
        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleEdit(record)">{{ $t('button.edit') }}</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <!--<a class="ant-dropdown-link"> {{ $t('button.more') }} <a-icon type="down" /> </a>-->
            <mtc-button type="link" size="small" text="button.more"><a-icon type="down" /></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <!--<a href="javascript:;" @click="handleDetail(record)">{{ $t('button.details') }}</a>-->
                <!--<a-popconfirm @confirm="() => handleDetail(record)">-->
                  <mtc-button @click="handleDetail(record)" type="link" size="small" text="button.details"></mtc-button>
                <!--</a-popconfirm>-->
              </a-menu-item>
              <a-menu-item>
                <!--<a href="javascript:;" @click="handleAddSub(record)">{{$t('button.addSubordinate')}}</a>-->
              <mtc-button @click="handleAddSub(record)" type="link" size="small" text="button.addSubordinate"></mtc-button>
              </a-menu-item>
              <a-menu-item>
                <!--<a href="javascript:;" @click="handleDataRule(record)">{{$t('button.dataRules')}}</a>-->
               <mtc-button @click="handleDataRule(record)" type="link" size="small" text="button.dataRules"></mtc-button>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{ $t('button.delete') }}</a>-->
                  <mtc-button :title="$t('tip.isDelete')" type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>

              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <!-- 字符串超长截取省略号显示 -->
        <span slot="url" slot-scope="text">
          <j-ellipsis :value="text" :length="25" />
        </span>
        <!-- 字符串超长截取省略号显示-->
        <span slot="component" slot-scope="text">
          <j-ellipsis :value="text" />
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <permission-modal ref="modalForm" @ok="modalFormOk"></permission-modal>
    <permission-data-rule-list ref="PermissionDataRuleList" @ok="modalFormOk"></permission-data-rule-list>
  </a-card>
</template>

<script>
import PermissionModal from './modules/PermissionModal'
import { getPermissionList } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import PermissionDataRuleList from './PermissionDataRuleList'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { MTC_AUTH } from '@api/servers'

const columns = [
  {
    slotName: 'tableHeader.menuName',
    // title: '菜单名称',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name', title: 'tableHeader.menuName' }
  },
  {
    slotName: 'tableHeader.menuType',
    // title: '菜单类型',
    dataIndex: 'menuType',
    key: 'menuType',
    // customRender: function (text) {
    //   if (text == 0) {
    //     return this.$t('label.menu')
    //   } else if (text == 1) {
    //     return this.$t('label.menu')
    //   } else if (text == 2) {
    //     return this.$t('label.buttonsPermissions')
    //   } else {
    //     return text
    //   }
    // },
    scopedSlots: { customRender: 'menuType', title: 'tableHeader.menuType' }
  },
  /*{
      title: '权限编码',
      dataIndex: 'perms',
      key: 'permissionCode',
    },*/ {
    slotName: 'tableHeader.icon',
    // title: 'icon',
    dataIndex: 'icon',
    key: 'icon',
    scopedSlots: { customRender: 'icon', title: 'tableHeader.icon' }
  },
  {
    slotName: 'tableHeader.frontComponents',
    // title: '组件',
    dataIndex: 'component',
    key: 'component',
    scopedSlots: { customRender: 'component', title: 'tableHeader.frontComponents' }
  },
  {
    slotName: 'tableHeader.menuPath',
    // title: '路径',
    dataIndex: 'url',
    key: 'url',
    scopedSlots: { customRender: 'url', title: 'tableHeader.menuPath' }
  },
  {
    slotName: 'tableHeader.sort',
    // title: '排序',
    dataIndex: 'sortNo',
    key: 'sortNo',
    scopedSlots: { title: 'tableHeader.sort' }
  },
  {
    slotName: 'tableHeader.operation',
    // title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
    align: 'center',
    width: 150
  }
]

export default {
  name: 'PermissionList',
  title: '菜单管理',
  mixins: [JeecgListMixin],
  components: {
    PermissionDataRuleList,
    PermissionModal,
    JEllipsis
  },
  data() {
    return {
      // 表头
      columns: columns,
      loading: false,
      // 展开的行，受控属性
      expandedRowKeys: [],
      url: {
        list: `${MTC_AUTH}sys/permission/list`,
        delete: `${MTC_AUTH}sys/permission/delete`,
        deleteBatch: `${MTC_AUTH}sys/permission/deleteBatch`
      }
    }
  },
  methods: {
    // loadData() {
    //   this.dataSource = []
    //   getPermissionList().then((res) => {
    //     if (res.success) {
    //       console.log(res.result)
    //       this.dataSource = res.result
    //     }
    //   })
    // },
    // 打开数据规则编辑
    handleDataRule(record) {
      this.$refs.PermissionDataRuleList.edit(record)
    },
    handleAddSub(record) {
      this.$refs.modalForm.title = this.$t('modalTitle.addSubmenu')
      this.$refs.modalForm.localMenuType = 1
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.edit({ status: '1', permsType: '1', route: true, parentId: record.id })
    },
    handleExpandedRowsChange(expandedRows) {
      this.expandedRowKeys = expandedRows
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>